import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { newVmDbSystemUpdateTags, VmDbSystemUpdateTagsProps } from "./VmDbSystemUpdateTags";

export interface VmDbSystemEditTagsProps extends OperationActionProps {
  dbSystemId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultTags?: { name: string; value: any; }[];
}

const VmDbSystemEditTags = (
  { targetId, location, dbSystemId, defaultTags, onExecute, onCancel }: VmDbSystemEditTagsProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsSystem } = useOperation<VmDbSystemUpdateTagsProps>(newVmDbSystemUpdateTags);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tags: { name: string; value: any; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTagsSystem({
          dbSystemId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newVmDbSystemEditTags = (
  props: VmDbSystemEditTagsProps,
): JSX.Element => (<VmDbSystemEditTags {...props} />);
